class Toggle {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-toggle',
            toggleClassname: 'toggle--hidden'
        };

        this.settings = Object.assign({}, defaults, options);

        this.$toggle = $element;

        this.initialize();
    }

    initialize () {
        const toggleId = this.$toggle.getAttribute(this.settings.initAttr).trim();
        if (toggleId !== '') {
            this.$toggleTarget = document.querySelector(toggleId);

            if (this.$toggleTarget !== null) {
                this.setEvents();
            }
        }
    }

    setEvents () {
        this.$toggle.addEventListener('change', (e) => {
            e.preventDefault();
            this.toggle(this.$toggle.checked);
        });
    }

    toggle (show) {
        if (show === true) {
            this.$toggleTarget.classList.remove(this.settings.toggleClassname);
        } else {
            this.$toggleTarget.classList.add(this.settings.toggleClassname);
        }
    }
}

export { Toggle };
